import { Modal, Form, Row, Col } from 'antd';
import lodashValues from 'lodash/values';
import zipObjectDeep from 'lodash/zipObjectDeep';
import { editDeliveryInformation } from '@redux/orders/actions';
import { useTranslation } from 'react-i18next';
import crudSelectors from '@redux/crudSelectors';
import { useDispatch, useSelector } from '@redux';
import { DynamicObjectType } from 'types/commons';
import { RestInputContext } from 'components/form/RestInputContext';
import FormItem from 'components/form/FormItem';
import VNCitySelector from './VNCitySelector';
// import FormCheckbox from 'components/form/FormCheckbox';

interface IEditShippingAddressModalProps {
  visible: boolean;
  onCancel: () => void;
  customHandleSubmit?: any;
  title?: string;
}

const EditShippingAddressModal = ({
  visible,
  onCancel,
  customHandleSubmit,
  title,
}: IEditShippingAddressModalProps) => {
  const { t } = useTranslation();
  const record = useSelector<DynamicObjectType>(
    (state) => state.orders.currentData,
  );
  const cities = useSelector<DynamicObjectType>(
    (state) => state.config.address,
  );
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const loading = useSelector(crudSelectors.orders.getLoadingCurrentRecord);

  const handleSubmit = (values) => {
    const payload: DynamicObjectType = zipObjectDeep(
      Object.keys(values || {}),
      lodashValues(values),
    );
    const province = cities?.find((e) => e.id === payload?.address?.provinceId);
    const district = province?.districts?.find(
      (e) => e.id === payload?.address?.districtId,
    );
    const ward = district?.wards?.find(
      (e) => e.id === payload?.address?.wardId,
    );
    if (customHandleSubmit) {
      customHandleSubmit({
        data: {
          id: record?.id,
          data: {
            address: {
              ...payload.address,
              ward: ward?.name,
              province: province?.name,
              district: district?.name,
            },
            packageInfo: payload.packageInfo,
          },
        },
        options: {},
      }).then(() => {
        onCancel();
        form.resetFields();
      });
      return;
    }
    dispatch(
      editDeliveryInformation({
        data: {
          id: record?.id,
          data: {
            address: {
              ...payload.address,
              ward: ward?.name,
              province: province?.name,
              district: district?.name,
            },
            packageInfo: payload.packageInfo,
          },
        },
        options: {},
      }),
    ).then(() => {
      onCancel();
      form.resetFields();
    });
  };

  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      title={title || t('orderDetail.editShippingInfo')}
      onOk={() => form.submit()}
      width={700}
      okButtonProps={{
        loading,
      }}
    >
      <Form
        form={form}
        onFinish={handleSubmit}
        layout="vertical"
        initialValues={record}
      >
        <RestInputContext.Provider value={{ form, record }}>
          <Row gutter={[14, 14]}>
            <Col span={12}>
              <FormItem
                name={['address', 'firstName']}
                label={t('shippingInfo.name')}
                required
              />
            </Col>
            <Col span={12}>
              <FormItem
                name={['address', 'lastName']}
                label={t('shippingInfo.surname')}
                required
              />
            </Col>
            <Col span={12}>
              <FormItem
                name={['address', 'telephone']}
                label={t('shippingInfo.telephone')}
                required
              />
            </Col>
            <Col span={12}>
              <FormItem
                name={['address', 'email']}
                label={t('shippingInfo.email')}
                required
              />
            </Col>
            <VNCitySelector rootSource="address" required />

            <Col span={24}>
              <FormItem
                name={['address', 'addressLine1']}
                label={t('Address')}
                required
              />
            </Col>
            <Col span={24}>
              <FormItem
                name={['address', 'addressLine2']}
                label={t('Address Name (Office, House name)')}
              />
            </Col>
            {/* <Col span={24}>
              <FormCheckbox name={['address', 'isDefault']}>
                Set as default address
              </FormCheckbox>
            </Col> */}
          </Row>
        </RestInputContext.Provider>
      </Form>
    </Modal>
  );
};

export default EditShippingAddressModal;
